import {Utilities} from '../../shared/utilities/utilities.model';
/**
 * Created by francesco on 21/11/17.
 */

export abstract class DigitalSignCheckItem {
	abstract value = false;
	abstract required: boolean;
	abstract title: number;
	abstract description: number;
}

export abstract class DigitalSignCheckList {
	abstract reference_type: number;
	abstract checklist: DigitalSignCheckItem[];

	isAllChecked(): boolean {
		if (Utilities.isVoid(this.checklist) || this.checklist.length === 0) {
			return true;
		}
		for (let i = 0; i < this.checklist.length; i++) {
			if (this.checklist[i].required && !this.checklist[i].value) {
				return false;
			}
		}
		return true;
	}
}

